module.exports = __webpack_public_path__ + "img/camera.bb8295f3.svg";